/** Serbian for API text shared by every area (error titles), keyed by the exact English text the API sends. */
export const text: Record<string, string> = {
  'Not found': 'Nije pronađeno',
  'Origin not allowed': 'Pristup sa ove adrese nije dozvoljen',
  'Authentication required': 'Potrebna je prijava',
  'Invalid authentication token': 'Token za prijavu nije ispravan',
  'Analytics access required': 'Potreban je pristup analitici',
  'This role cannot access this resource': 'Ova uloga nema pristup ovom delu',
  'Admin access required': 'Potreban je administratorski pristup',
  'Export download failed': 'Preuzimanje izvoza nije uspelo',
};

/** Text with variable parts (dates, counts, names). The first matching pattern wins. */
export const patterns: Array<[RegExp, (match: RegExpExecArray) => string]> = [
];
